const data = {
  data: {
    search: {
      hitcount: "1111",
      facets: [
        {
          name: "workTypes",
          values: [
            {
              term: "literature",
              key: "literature",
              count: 508470,
            },
            {
              term: "article",
              key: "article",
              count: 465761,
            },
            {
              term: "movie",
              key: "movie",
              count: 9979,
            },
            {
              term: "none",
              key: "none",
              count: 8515,
            },
            {
              term: "music",
              key: "music",
              count: 6247,
            },
          ],
        },
        {
          name: "mainLanguages",
          values: [
            {
              term: "Dansk",
              key: "dan",
              count: 643218,
            },
            {
              term: "Engelsk",
              key: "eng",
              count: 250163,
            },
            {
              term: "Tysk",
              key: "ger",
              count: 85682,
            },
            {
              term: "flere sprog",
              key: "mul",
              count: 8183,
            },
            {
              term: "Fransk",
              key: "fre",
              count: 3658,
            },
          ],
        },
        {
          name: "materialTypes",
          values: [
            {
              term: "e-bog",
              key: "ebog",
              count: 432386,
            },
            {
              term: "avisartikel",
              key: "avisartikel",
              count: 326943,
            },
            {
              term: "bog",
              key: "bog",
              count: 147371,
            },
            {
              term: "tidsskriftsartikel",
              key: "tidsskriftsartikel",
              count: 135102,
            },
            {
              term: "lydbog (net)",
              key: "lydbog (net)",
              count: 51918,
            },
          ],
        },
        {
          name: "fictionalCharacter",
          values: [
            {
              term: "Rasmus Klump",
              key: "Rasmus Klump",
              count: 120,
            },
            {
              term: "Maigret",
              key: "Maigret",
              count: 81,
            },
            {
              term: "Hercule Poirot",
              key: "Hercule Poirot",
              count: 73,
            },
            {
              term: "Mumitroldene",
              key: "Jack Reacher",
              count: 68,
            },
            {
              term: "Jack Reacher",
              key: "Jack Reacher",
              count: 61,
            },
          ],
        },
        {
          name: "genreAndForm",
          values: [
            {
              term: "krimi",
              key: "krimi",
              count: 5460,
            },
            {
              term: "erindringer",
              key: "erindringer",
              count: 4159,
            },
            {
              term: "spænding",
              key: "spænding",
              count: 3771,
            },
            {
              term: "fantasy",
              key: "fantasy",
              count: 2894,
            },
            {
              term: "dansk pop/rock",
              key: "dansk pop/rock",
              count: 2734,
            },
          ],
        },
        {
          name: "childrenOrAdults",
          values: [
            {
              term: "voksenmaterialer",
              key: "voksenmaterialer",
              count: 978413,
            },
            {
              term: "børnematerialer",
              key: "børnematerialer",
              count: 40290,
            },
          ],
        },
        {
          name: "accessTypes",
          values: [
            {
              term: "online",
              key: "online",
              count: 1006110,
            },
            {
              term: "physical",
              key: "fysiske",
              count: 590198,
            },
            {
              term: "none",
              key: "none",
              count: 516,
            },
          ],
        },
        {
          name: "fictionNonfiction",
          values: [
            {
              term: "nonfiktion",
              key: "nonfiktion",
              count: 775297,
            },
            {
              term: "fiktion",
              key: "fiktion",
              count: 76822,
            },
          ],
        },
        {
          name: "subjects",
          values: [
            {
              term: "historie",
              key: "historie",
              count: 35213,
            },
            {
              term: "politiske forhold",
              key: "politiske forhold",
              count: 32613,
            },
            {
              term: "Medicine",
              key: "Medicine",
              count: 28740,
            },
            {
              term: "Computer science",
              key: "Computer science",
              count: 27091,
            },
            {
              term: "kronikker",
              key: "kronikker",
              count: 24607,
            },
          ],
        },
        {
          name: "creators",
          values: [
            {
              term: "Association for Computing Machinery-Digital Library",
              key: "Association for Computing Machinery-Digital Library",
              count: 6209,
            },
            {
              term: "Poul Høi",
              key: "Poul Høi",
              count: 1409,
            },
            {
              term: "Jørgen Steen Nielsen",
              key: "Jørgen Steen Nielsen",
              count: 1137,
            },
            {
              term: "Martin Burcharth",
              key: "Martin Burcharth",
              count: 1097,
            },
            {
              term: "Litteratursiden",
              key: "Litteratursiden",
              count: 1089,
            },
          ],
        },
      ],
    },
  },
};

export default data;
